import OpeningApi from './_openingApi';
import httpClient from '@/apis/base/httpclient';

class OpeningSupplyEntryAPI extends OpeningApi {
  constructor() {
    super();
  }
  controllerName = 'OpeningSupplyEntrys';

  getOpeningSupplyEntryByDepartment(departmentId) {
    let request = { url: this.getAPIUrl() + `/OpeningSupplyEntryByDepartment?departmentId=${departmentId}` };

    return httpClient.getAsync(request);
  }

  saveOpeningSupplyEntryByDepartment(payload) {
    let request = { url: this.getAPIUrl() + `/OpeningSupplyEntryByDepartment`, data: payload };

    return httpClient.postAsync(request);
  }

  importOpeningSupplyEntry(sessionId) {
    let request = { url: this.getAPIUrl() + `/ImportOpeningSupplyEntry/${sessionId}` };

    return httpClient.postAsync(request);
  }
}

export default new OpeningSupplyEntryAPI();
